module.exports = __webpack_public_path__ + "static/media/emoji5.72b23613.svg";